/* eslint-disable no-alert */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { post } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import * as url from '../../helpers/url_helper';
import ItemFormModal from '../../components/Item/ItemFormModal';

function Items(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editModalItem, setEditModalItem] = useState({
    manufacturer: '',
    device_manufacturer: '',
    part_number: '',
    condition: 'Like New',
    tags: [],
    weight: null,
    ship_dims: '',
    customs_description: '',
    customs_value: 0,
  });
  const [signal, setSignal] = useState(0);

  const editItem = (item) => {
    setEditModalItem(item);
    setEditModalOpen(true);
  };

  const deleteItem = async (item, e) => {
    const btn = e.currentTarget;

    btn.disabled = true;
    btn.blur();
    btn.firstChild.classList.toggle('bx-spin');

    // eslint-disable-next-line no-restricted-globals
    const cnfrm = confirm(props.t(`Are you sure you want to delete ${item.sku}?`));

    if (cnfrm) {
      try {
        await post(url.DELETE_ITEM, { id: item.id });

        toastr.success(`Deleted item ID: ${item.id}`, 'Success');
        setSignal(signal + 1);
      } catch (error) {
        toastr.error(error.message, 'Error');
      } finally {
        btn.disabled = false;
        btn.firstChild.classList.toggle('bx-spin');
      }
    }
  };

  const onEditSuccess = () => {
    setSignal(signal + 1);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col lg="10">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Items')}</CardTitle>

                <Can i="see" this="Items">
                  <BaseGrid
                    url={url.GET_ITEMS}
                    shouldUpdate={signal}
                    className="table table-sm fs-6 table-nowrap table-hover table-bordered"
                    hasSearch
                    create="/items/create"
                    config={
                    {
                      columns: {
                        thumb: {
                          label: '',
                          image: {
                            src: (item) => (`/api/items/thumbnail/${item.id}`),
                            class: 'rounded',
                            style: { maxHeight: '3rem', maxWidth: '3rem' },
                          },
                          translate: false,
                        },
                        id: {
                          label: props.t('ID'),
                          sort: true,
                          link: {
                            to: '/item/%id%',
                          },
                        },
                        manufacturer: {
                          label: props.t('Manufacturer'),
                          sort: true,
                        },
                        part_number: {
                          label: props.t('Part Number'),
                          sort: true,
                          link: {
                            to: '/item/%id%',
                          },
                        },
                        condition: {
                          label: props.t('Condition'),
                          sort: true,
                        },
                        created_at: {
                          label: props.t('Created'),
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.LOCAL_TZ,
                          },
                          sort: true,
                        },
                        tags: {
                          label: 'Tags',
                          format: (x) => (x.map((r) => (r.label))),
                          badges: {
                            class: 'bg-info bg-soft text-dark p-1',
                          },
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'edit',
                              icon: 'bx bx-pencil',
                              class: 'btn btn-sm btn-primary btn-soft-primary',
                              alt: props.t('Edit'),
                              click: editItem,
                            },
                            {
                              key: 'delete',
                              icon: 'mdi mdi-delete',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteItem,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="Items"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <ItemFormModal shown={editModalOpen} item={editModalItem} onSuccess={onEditSuccess} />
    </div>
  );
}

Items.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Items));
